/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Findprospectsfromsalesforce_Noprospectsfound6Inputs */

const en_coinvestments_findprospectsfromsalesforce_noprospectsfound6 = /** @type {(inputs: Coinvestments_Findprospectsfromsalesforce_Noprospectsfound6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No matching prospects found`)
};

/**
* | output |
* | --- |
* | "No matching prospects found" |
*
* @param {Coinvestments_Findprospectsfromsalesforce_Noprospectsfound6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_findprospectsfromsalesforce_noprospectsfound6 = /** @type {((inputs?: Coinvestments_Findprospectsfromsalesforce_Noprospectsfound6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Findprospectsfromsalesforce_Noprospectsfound6Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_findprospectsfromsalesforce_noprospectsfound6(inputs)
});
export { coinvestments_findprospectsfromsalesforce_noprospectsfound6 as "coInvestments_findProspectsFromSalesforce_noProspectsFound" }